module.exports = __webpack_public_path__ + "static/media/iconfont.af570136.woff";